import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

//require('./scss/style.scss');

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
